import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InvoiceList from "../../components/invoices/InvoiceList";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function Invoices() {
  const { t } = useTranslation("accounts");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Invoices"),
      desc: t("View and manage all invoices here"),
    });
  }, [t]);
  
  return <div className="bg-white shadow rounded-lg mt-4 overflow-hidden">
    <InvoiceList />
  </div>;
}

